/* ============================================================
   Luxury Cart Toast System
   Shows a premium glassmorphic toast instead of opening the drawer
   ============================================================ */
if (!window.LuxuryCartToast) {
  window.LuxuryCartToast = {
    _timeout: null,
    _el: null,

    _buildEl() {
      const el = document.createElement('div');
      el.id = 'luxury-cart-toast';
      el.innerHTML = `
        <div class="lct__icon-wrap">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
        </div>
        <div class="lct__body">
          <p class="lct__message"></p>
          <div class="lct__actions">
            <button class="lct__btn lct__btn--cart">View Cart</button>
            <a href="/checkout" class="lct__btn lct__btn--checkout">Checkout →</a>
          </div>
        </div>
        <button class="lct__close" aria-label="Close">✕</button>
        <div class="lct__progress"></div>
      `;
      el.querySelector('.lct__close').addEventListener('click', () => this.hide());

      // "View Cart" opens the drawer, not the /cart page
      el.querySelector('.lct__btn--cart').addEventListener('click', () => {
        this.hide();
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          // Fallback: click the cart icon button in the header
          const cartBtn = document.querySelector('[href="/cart"], .cart-count-bubble')?.closest('a, button');
          if (cartBtn) cartBtn.click();
        }
      });
      document.body.appendChild(el);
      this._el = el;
    },

    show(message) {
      if (!this._el) this._buildEl();

      // Reset progress animation
      const progress = this._el.querySelector('.lct__progress');
      progress.style.transition = 'none';
      progress.style.width = '100%';

      this._el.querySelector('.lct__message').textContent = message;
      this._el.classList.remove('lct--hide');
      this._el.classList.add('lct--show');

      // Trigger reflow then animate progress bar
      this._el.getBoundingClientRect();
      progress.style.transition = 'width 4s linear';
      progress.style.width = '0%';

      // Clear any existing dismiss timer
      clearTimeout(this._timeout);
      this._timeout = setTimeout(() => this.hide(), 4000);
    },

    hide() {
      if (!this._el) return;
      clearTimeout(this._timeout);
      this._el.classList.remove('lct--show');
      this._el.classList.add('lct--hide');
    }
  };

  /* Inject toast CSS */
  const style = document.createElement('style');
  style.textContent = `
    #luxury-cart-toast {
      position: fixed;
      bottom: 2rem;
      left: 50%;
      top: auto;
      right: auto;
      z-index: 99999;
      width: calc(100% - 4rem);
      max-width: 36rem;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(28px) saturate(180%);
      -webkit-backdrop-filter: blur(28px) saturate(180%);
      border: 1px solid rgba(46, 99, 149, 0.15);
      border-radius: 16px;
      box-shadow: 0 16px 48px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06);
      padding: 1.8rem 2rem 1.4rem;
      display: flex;
      align-items: flex-start;
      gap: 1.4rem;
      overflow: hidden;
      pointer-events: none;
      opacity: 0;
      transform: translate(-50%, calc(100% + 3rem));
      transition: opacity 0.4s cubic-bezier(0.16,1,0.3,1), transform 0.4s cubic-bezier(0.16,1,0.3,1);
    }
    #luxury-cart-toast.lct--show {
      pointer-events: all;
      opacity: 1;
      transform: translate(-50%, 0);
    }
    #luxury-cart-toast.lct--hide {
      opacity: 0;
      transform: translate(-50%, calc(100% + 3rem));
      pointer-events: none;
    }
    .lct__icon-wrap {
      flex-shrink: 0;
      width: 3.6rem;
      height: 3.6rem;
      background: rgba(46,99,149,0.1);
      border: 1px solid rgba(46,99,149,0.2);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #2e6395;
      margin-top: 0.1rem;
    }
    .lct__body {
      flex: 1;
      min-width: 0;
    }
    .lct__message {
      font-size: 1.35rem;
      font-weight: 500;
      color: #1a1a1a;
      margin: 0 0 1.2rem 0;
      line-height: 1.5;
      letter-spacing: 0.01em;
    }
    .lct__actions {
      display: flex;
      gap: 0.8rem;
    }
    .lct__btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0.6rem 1.2rem;
      border-radius: 7px;
      font-size: 1.2rem;
      font-weight: 500;
      text-decoration: none !important;
      transition: all 0.2s ease;
      letter-spacing: 0.03em;
      cursor: pointer;
    }
    .lct__btn--cart {
      background: rgba(46,99,149,0.08);
      border: 1px solid rgba(46,99,149,0.25);
      color: #2e6395 !important;
    }
    .lct__btn--cart:hover {
      background: rgba(46,99,149,0.15);
      color: #2e6395 !important;
    }
    .lct__btn--checkout {
      background: #2e6395;
      border: 1px solid #2e6395;
      color: #ffffff !important;
      font-weight: 600;
    }
    .lct__btn--checkout:hover {
      background: #1a3d5c;
      border-color: #1a3d5c;
      box-shadow: 0 4px 14px rgba(46,99,149,0.25);
    }
    .lct__close {
      flex-shrink: 0;
      background: none;
      border: none;
      color: rgba(0,0,0,0.3);
      font-size: 1.2rem;
      cursor: pointer;
      padding: 0;
      line-height: 1;
      margin-top: 0.1rem;
      transition: color 0.2s ease;
      min-height: 0 !important;
      box-shadow: none !important;
    }
    .lct__close:hover {
      color: rgba(0,0,0,0.65);
    }
    .lct__progress {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      width: 100%;
      background: linear-gradient(90deg, #2e6395, rgba(46,99,149,0.3));
      border-radius: 0 0 16px 16px;
    }
  `;
  document.head.appendChild(style);
}

if (!customElements.get('luxury-qty-selector')) {
  customElements.define('luxury-qty-selector', class LuxuryQtySelector extends HTMLElement {
    constructor() {
      super()
      this.variantId = this.getAttribute('data-variant-id');
      this.productTitle = this.getAttribute('data-product-title') || 'Product';
      this.qty = parseInt(this.getAttribute('data-qty')) || 0;
      
      this.plusOnlyBtn = this.querySelector('.luxury-qty-btn--plus-only');
      this.controls = this.querySelector('.luxury-qty-controls');
      this.minusBtn = this.querySelector('.luxury-qty-btn--minus');
      this.plusBtn = this.querySelector('.luxury-qty-btn--plus');
      this.valueSpan = this.querySelector('.luxury-qty-value');
      
      // Reference cart but never open it — only use for section re-rendering
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.isUpdating = false;
    }

    connectedCallback() {
      this.plusOnlyBtn.addEventListener('click', this.addToCart.bind(this));
      this.minusBtn.addEventListener('click', (e) => this.updateQuantity(e, -1));
      this.plusBtn.addEventListener('click', (e) => this.updateQuantity(e, 1));
      
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    _getProductTitle() {
      // Try to read from the card heading above this element
      const card = this.closest('.card-wrapper, .card--luxury, article');
      if (card) {
        const heading = card.querySelector('.card__heading a, h3 a, h2 a');
        if (heading) return heading.textContent.trim();
      }
      return this.productTitle;
    }

    _updateCartCount(response) {
      // Publish so other components (mini-cart count, etc.) stay in sync
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'luxury-qty-selector',
          productVariantId: this.variantId,
          cartData: response
        });
      }
      // Update the cart-icon-bubble count only (drawer is already open for qty changes)
      const bubbleSection = (response.sections || {})['cart-icon-bubble'];
      if (bubbleSection) {
        const bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl) {
          const temp = document.createElement('div');
          temp.innerHTML = bubbleSection;
          const newBubble = temp.querySelector('.shopify-section');
          if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
        }
      }
    }

    // Re-render the cart drawer DOM silently (no open()) so we can show a toast
    // instead of popping open the drawer on every add-to-cart.
    // Replicates what CartDrawer.renderContents does, minus the this.open() call.
    _renderCartDrawerSilently(sectionsData) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      // 1. Strip is-empty so CSS shows cart items, not the empty state
      cartDrawer.classList.remove('is-empty');
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner) drawerInner.classList.remove('is-empty');

      // 2. Replace #CartDrawer innerHTML with the freshly rendered server HTML
      const cartDrawerEl = document.querySelector('#CartDrawer');
      if (cartDrawerEl && sectionsData['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(sectionsData['cart-drawer'], 'text/html');
        const source = parsed.querySelector('#CartDrawer');
        if (source) cartDrawerEl.innerHTML = source.innerHTML;
      }

      // 3. Update cart-icon-bubble count
      const bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl && sectionsData['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
        const source = parsed.querySelector('.shopify-section');
        if (source) bubbleEl.innerHTML = source.innerHTML;
      }

      // 4. Re-bind the overlay close listener since innerHTML was replaced
      const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
    }

    addToCart(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (this.isUpdating) return;
      this.isUpdating = true;
      this.plusOnlyBtn.classList.add('is-loading');
      
      const addTextSpan = this.plusOnlyBtn.querySelector('.add-text');
      const originalText = addTextSpan ? addTextSpan.textContent : 'Add';
      if (addTextSpan) addTextSpan.textContent = 'Adding';
      
      // Ask Shopify to return the updated cart-drawer and cart-icon-bubble sections
      // in the same response — this is what product-form.js does natively.
      const sectionsNeeded = ['cart-drawer', 'cart-icon-bubble'];
      
      fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: this.variantId,
          quantity: 1,
          sections: sectionsNeeded,
          sections_url: window.location.pathname
        })
      })
      .then(r => r.json())
      .then(response => {
        if (response.status === 422 || response.errors) {
          throw new Error(response.description || 'Error adding to cart');
        }
        
        this.qty = 1;
        this.valueSpan.textContent = this.qty;
        
        // Animate plus button → quantity controls
        this.plusOnlyBtn.style.display = 'none';
        this.controls.style.display = 'flex';
        this.controls.style.opacity = '0';
        this.controls.style.transform = 'scale(0.8)';
        this.controls.getBoundingClientRect();
        this.controls.style.transition = 'all 0.35s cubic-bezier(0.16, 1, 0.3, 1)';
        this.controls.style.opacity = '1';
        this.controls.style.transform = 'scale(1)';
        
        // Show toast notification
        window.LuxuryCartToast.show(`"${this._getProductTitle()}" added to your cart.`);
        
        // Use _renderCartDrawerSilently to update the full drawer DOM without
        // opening it — so the toast shows but the drawer stays closed.
        if (response.sections) {
          this._renderCartDrawerSilently(response.sections);
        }
      })
      .catch(err => console.error(err))
      .finally(() => {
        this.plusOnlyBtn.classList.remove('is-loading');
        if (addTextSpan) addTextSpan.textContent = originalText;
        this.isUpdating = false;
      });
    }

    updateQuantity(e, change) {
      e.preventDefault();
      e.stopPropagation();
      
      if (this.isUpdating) return;
      this.isUpdating = true;
      
      const newQty = this.qty + change;
      const sections = this.cart ? this.cart.getSectionsToRender().map((s) => s.id || s.section) : [];
      
      fetch(`${window.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: this.variantId,
          quantity: newQty,
          sections: sections,
          sections_url: window.location.pathname
        })
      })
      .then(r => r.json())
      .then(response => {
        if (response.status === 422 || response.errors) {
          throw new Error(response.description || 'Error updating quantity');
        }
        
        this.qty = newQty;
        this.valueSpan.textContent = this.qty;
        
        if (newQty === 0) {
          this.controls.style.transition = 'all 0.25s ease';
          this.controls.style.opacity = '0';
          this.controls.style.transform = 'scale(0.8)';
          setTimeout(() => {
            this.controls.style.display = 'none';
            this.plusOnlyBtn.style.display = 'flex';
            this.plusOnlyBtn.style.opacity = '0';
            this.plusOnlyBtn.style.transform = 'scale(0.8)';
            this.plusOnlyBtn.getBoundingClientRect();
            this.plusOnlyBtn.style.transition = 'all 0.35s cubic-bezier(0.16, 1, 0.3, 1)';
            this.plusOnlyBtn.style.opacity = '1';
            this.plusOnlyBtn.style.transform = 'scale(1)';
          }, 250);
          
          // Show removed toast
          window.LuxuryCartToast.show(`"${this._getProductTitle()}" removed from your cart.`);
        } else {
          // Show quantity updated toast
          window.LuxuryCartToast.show(`"${this._getProductTitle()}" quantity updated to ${newQty}.`);
        }
        
        this._updateCartCount(response);
      })
      .catch(err => console.error(err))
      .finally(() => { this.isUpdating = false; });
    }

    onCartUpdate(event) {
      if (event.source === 'luxury-qty-selector') return;
      
      const cartData = event.cartData;
      if (!cartData || !cartData.items) return;
      
      const item = cartData.items.find(i => String(i.variant_id) === String(this.variantId));
      const newQty = item ? item.quantity : 0;
      
      if (newQty === this.qty) return;
      this.qty = newQty;
      this.valueSpan.textContent = this.qty;
      
      if (this.qty > 0) {
        this.plusOnlyBtn.style.display = 'none';
        this.controls.style.display = 'flex';
        this.controls.style.opacity = '1';
        this.controls.style.transform = 'scale(1)';
      } else {
        this.controls.style.display = 'none';
        this.plusOnlyBtn.style.display = 'flex';
        this.plusOnlyBtn.style.opacity = '1';
        this.plusOnlyBtn.style.transform = 'scale(1)';
      }
    }
  });
}


// Observe sliders within luxury collection container
document.addEventListener('DOMContentLoaded', () => {
  const initLuxurySlider = () => {
    const sliders = document.querySelectorAll('.collection--luxury slider-component');
    sliders.forEach(slider => {
      const bar = slider.querySelector('.luxury-slider__progress-bar');
      if (!bar) return;
      
      const updateProgress = () => {
        const totalPages = slider.totalPages || 1;
        const currentPage = slider.currentPage || 1;
        bar.style.width = `${(currentPage / totalPages) * 100}%`;
      };

      slider.addEventListener('slideChanged', updateProgress);
      
      // Update once slider component settles (totalPages calculation delay)
      setTimeout(updateProgress, 350);
      window.addEventListener('resize', updateProgress);
    });
  };

  initLuxurySlider();
  
  // Watch for dynamic insertions of slider-components (e.g., from product recommendations loading dynamically)
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'SLIDER-COMPONENT' || node.querySelector('slider-component')) {
            shouldInit = true;
            break;
          }
        }
      }
      if (shouldInit) break;
    }
    if (shouldInit) {
      initLuxurySlider();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Re-run on Shopify Theme Editor section load/unload
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.collection--luxury')) {
      initLuxurySlider();
    }
  });
});
